export default "__VITE_ASSET__CMmwPgXp__"